import { useCallback, useState } from 'react';
import { Theme } from '@mui/material/styles';
import { scrollTopHelper } from 'helpers/scroll-helper';

export interface IStoreService {
  state: IStateProps;
  setAppSelector: (appSelector: string) => void;
  setMarketConfig: (marketConfig: TimApp.MarketConfiguration) => void;
  setWidgetLoaded: (widgetLoaded: boolean) => void;
  setTaggingData: (tagging: Record<string, string | number>) => void;
  setTheme: (theme: Theme) => void;
  setUrlOffer: (urlOffer: string) => void;
  getTaggingData: () => Record<string, string | number>;
  getMarketConfig: () => TimApp.MarketConfiguration;
  scrollTop: (options?: ScrollIntoViewOptions) => void;
  setActiveStep: (nextStep: number) => void;
  setThemeModel: (themeModel: string) => void;
}

export interface IStateProps {
  appSelector: string;
  marketConfig: TimApp.MarketConfiguration;
  widgetLoaded: boolean;
  theme: Theme;
  urlOffer: string;
  typeCar: string;
  tagging: Record<string, string | number>;
  activeStep: number;
  themeModel?: string;
}

export const initialState: IStateProps = {
  appSelector: '',
  marketConfig: {} as TimApp.MarketConfiguration,
  widgetLoaded: false,
  theme: {} as Theme,
  urlOffer: '',
  typeCar: '',
  tagging: {},
  activeStep: 0,
  themeModel: '',
};

export const useStore = (): IStoreService => {
  const [appSelector, setAppSelector] = useState<string>('');
  const [marketConfig, setMarketConfig] = useState<TimApp.MarketConfiguration>({} as TimApp.MarketConfiguration);
  const [widgetLoaded, setWidgetLoaded] = useState<boolean>(false);
  const [theme, setTheme] = useState<Theme>({} as Theme);
  const [urlOffer, setUrlOffer] = useState<string>('');
  const [typeCar] = useState<string>('');
  const [tagging, setTaggingData] = useState<Record<string, string | number>>({} as Record<string, string | number>);
  const [activeStep, setActiveStep] = useState(0);
  const [themeModel, setThemeModel] = useState<string>('');

  const getTaggingData = (): Record<string, string | number> => tagging;

  const getMarketConfig = (): TimApp.MarketConfiguration => marketConfig;

  const scrollTop = useCallback(
    (options?: ScrollIntoViewOptions): void => {
      scrollTopHelper(appSelector, options);
    },
    [appSelector]
  );

  return {
    state: {
      appSelector,
      marketConfig,
      tagging,
      theme,
      typeCar,
      urlOffer,
      widgetLoaded,
      activeStep,
      themeModel,
    },
    setAppSelector,
    setMarketConfig,
    setWidgetLoaded,
    setTaggingData,
    setTheme,
    setUrlOffer,
    getTaggingData,
    getMarketConfig,
    scrollTop,
    setActiveStep,
    setThemeModel,
  };
};
